// Central configuration so phone/address/etc. can be tweaked from one place.
export const SITE = {
  name: "Gurukul Classes",
  tagline: "Focused Learning. Consistent Results.",
  phoneDisplay: "+91 99878 84688",
  // E.164 (no spaces, no plus) for wa.me links
  whatsappNumber: "919987884688",
  // tel: link form
  phoneTel: "+919987884688",
  address:
    "Vitawa, near Kunkai Devi Mandir, Priyanka Paradise, Thane, Maharashtra",
  shortAddress: "Vitawa, Thane",
  instagramUrl: "#",
  facebookUrl: "#",
  // Google Maps embed query
  mapQuery: "Gurukul Classes Vitawa Thane Priyanka Paradise Kunkai Devi Mandir",
};

export const buildWhatsAppLink = (text) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;
